export * from "./hotel-reserve-card-detail";
